import { Observable } from 'rxjs';

import { FileGroup } from './file-group';
import { FileGroupsApiService } from './file-groups.api.service';
import { Injectable } from '@angular/core';

@Injectable()
export class FileGroupsService {
  constructor(private fileGroupsApiService: FileGroupsApiService) {}

  private _loading = false;

  public get loading(): boolean {
    return this._loading;
  }

  load(accountId: string, appId: string): Observable<any> {
    return this.fileGroupsApiService.fetch(accountId, appId);
  }

  create(accountId: string, fileGroup: FileGroup, appId: string): Observable<FileGroup> {
    return this.fileGroupsApiService.create(accountId, fileGroup, appId);
  }

  update(accountId: string, fileGroup: FileGroup, appId: string): Observable<FileGroup> {
    return this.fileGroupsApiService.update(accountId, fileGroup, appId);
  }

  delete(accountId: string, fileGroupId: string, appId: string): Observable<FileGroup> {
    return this.fileGroupsApiService.delete(accountId, fileGroupId, appId);
  }
}
